import * as React from "react";
import Card from "./Card/Card";
import { Book } from "../../types/Book";
import "./Feed.css";
import getCollection from "../../requests/getCollection";
import { CardsManagerCallbacks } from "../CardsManager/CardsManager";
import { useSelector } from "react-redux";
import { getCollections } from "../../store/collections/selectors";
import CollectionCard from "../CollectionCard/CollectionCard";
import { useHistory, useParams } from "react-router-dom";
import FeedHeader from "./FeedHeader/FeedHeader";
import { CollectionShort } from "../../types/Collection";
import FeedList from "./FeedList/FeedList";
import cn from "classnames";
import { API_URL } from "../../utils";

interface Props {
	callbacks: CardsManagerCallbacks;
	limit?: number;
}

export const FeedCallbacksContext = React.createContext<CardsManagerCallbacks>(
	null
);

const Feed: React.FC<Props> = (props) => {
	const [books, setBooks] = React.useState<Book[]>([]);
	const [loading, setLoading] = React.useState(false);
	const [collection, setCollection] = React.useState<CollectionShort>(null);
	const [collections, setCollections] = React.useState([]);
	const [page, setPage] = React.useState(1);

	const [opened, setOpen] = React.useState(false);

	const route = useParams<{ id: string }>();
	const history = useHistory();

	const collectionId = React.useMemo(() => {
		return route?.id || 0;
	}, [route?.id]);

	React.useEffect(() => {
		if (collection?.id === 0) {
			fetch(`${API_URL}/collections/list`, {
				credentials: "include",
			})
				.then((data) => {
					return data.json();
				})
				.then((data) => {
					setCollections(data as any);
				});
		}
	}, [collection]);

	React.useEffect(() => {
		setLoading(true);

		getCollection(collectionId as any, page).then((data) => {
			setCollection(data);
			setLoading(false);
		});
	}, [collectionId]);

	const onMoreLoad = () => {
		setLoading(true);

		getCollection(collectionId as any, page + 1).then((data) => {
			if (data.books.length > 0) {
				setPage(page + 1);

				setCollection({
					...collection,
					books: [...collection.books, ...data.books],
				});
			} else {
				setPage(-1);
			}

			setLoading(false);
		});
	};

	const collectionsArray = React.useMemo(() => {
		if (!collections.length) {
			return [];
		}

		return collections
			.filter((collection) => collection.id !== 20)
			.slice(0, opened ? collections.length : 5);
	}, [collections, opened]);

	return (
		<div className="feed">
			{!loading && collection && collection.id > 0 && (
				<FeedHeader
					backgroundUrl={collection.bigImage || collection.image}
					header={collection.name}
					onBack={() => history.goBack()}
				/>
			)}

			<div className="feed-header">
				{!collection || (collection.id as any) === 0
					? "Популярное"
					: collection.name}
			</div>

			{(!collection || (collection?.id as any) === 0) && collections.length > 0 && (
				<div
					className={cn("feed-collections", {
						"feed-collections_open": opened,
					})}
				>
					{collectionsArray.map((collection) => (
						<CollectionCard
							key={collection.id}
							imageURL={collection.image}
							header={collection.name}
							isSelected={collection.id == collectionId}
							action={`/list/category-${collection.id}`}
						/>
					))}

					{!opened && (
						<CollectionCard
							header="Еще..."
							action={() => setOpen(true)}
							imageURL={null}
						/>
					)}
				</div>
			)}

			<FeedList
				books={collection?.books}
				loading={loading}
				limit={props.limit}
				onMoreLoad={onMoreLoad}
				page={collection?.id > 0 ? page : -1}
			/>

			{props.limit > 0 && (
				<div className="feed-more">
					<CollectionCard header="Показать все" action="/list" imageURL="" />
				</div>
			)}
		</div>
	);
};

export default Feed;
